import React, { useState, useRef, useEffect } from 'react'
import DOMPurify from 'dompurify'
import { Link, makeStyles } from '@material-ui/core'

const RichTextRenderer = ({ htmlContent }) => {
  const classes = useStyles()
  const [isClamped, setIsClamped] = useState(true)
  const sanitizedHtml = DOMPurify.sanitize(htmlContent)

  const [showLink, setShowLink] = useState(false)
  const contentRef = useRef(null)

  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.scrollHeight
      // Assuming 6 lines is approximately 100px in height
      setShowLink(height > 100)
    }
  }, [sanitizedHtml])

  return (
    <div>
      <div
        ref={contentRef}
        className={isClamped ? classes.clampedContent : ''}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
      {showLink && (
        <Link className={classes.button} onClick={() => setIsClamped(!isClamped)}>
          {!isClamped ? 'View less...' : 'View more...'}
        </Link>
      )}
    </div>
  )
}

export default RichTextRenderer

const useStyles = makeStyles((theme) => ({
  clampedContent: {
    display: '-webkit-box',
    '-webkit-line-clamp': 6,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
    ul: {
      'padding-inline-start': '40px'
    }
  },
  button: {
    marginLeft: '10px',
    color: theme.palette.primary.main,
    letterSpacing: '0.65px',
    textTransform: 'none !important',
    marginTop: '8px',
    cursor: 'pointer'
  }
}))
